const callToast = props =>
  window.PLURALL_ELO_TOAST_CONTAINER?.addToast?.({
    ...props,
  })

export default callToast
